import { render, staticRenderFns } from "./ExtraPaymentList.vue?vue&type=template&id=6a5a01b2&scoped=true&"
import script from "./ExtraPaymentList.vue?vue&type=script&lang=ts&"
export * from "./ExtraPaymentList.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraPaymentList.vue?vue&type=style&index=0&id=6a5a01b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5a01b2",
  null
  
)

export default component.exports